import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function WelcomePage() {
  const { t } = useTranslation();
  return (
    <section className="welcome-wrap">
      <article className="welcome-card">
        <h2>{t('welcome.title')}</h2>
        <p>{t('welcome.desc')}</p>
        <Link to="/emails" className="quick-link">{t('welcome.goToInbox')}</Link>
      </article>
    </section>
  );
}
